var _effectorFileName = "/builds/gmini/front-ui-kit/src/Page404/Page404.styled.ts";
import styled from 'styled-components';
import { PathIcon } from './PathIcon';
import { FlyIcon } from './FlyIcon';
export const Page404HugeTextWrapper = styled.div`
  position: relative;
  width: min-content;
  margin-top: 100px;
`;
export const Page404HugeText = styled.div`
  font-weight: 500;
  color: #353b60;
  font-size: 140px;
  line-height: 164px;
  letter-spacing: 0.1;
  margin-bottom: 19px;
  width: min-content;
`;
export const OrangeDotSVG = styled.svg`
  position: absolute;
  bottom: 31.5px;
  right: 8.5px;
`;
export const PathPositioned = styled(PathIcon)`
  position: absolute;
  bottom: 30px;
  left: 8px;
`;
export const FlyPositioned = styled(FlyIcon)`
  position: absolute;
  right: -127px;
  top: 11px;
`;
export const Page404Link = styled.a`
  text-decoration: none;
  color: rgb(76, 94, 207);
`;